import { render } from "./FormModel.vue?vue&type=template&id=8b8222b2"
import script from "./FormModel.vue?vue&type=script&lang=js"
export * from "./FormModel.vue?vue&type=script&lang=js"

import "./FormModel.vue?vue&type=style&index=0&id=8b8222b2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__